export type ConsolidationTab =
  | 'consolidation-groups'
  | 'chart-of-accounts'
  | 'intercompany-sets';

export type SglSection = 'mapped-sgl' | 'unmapped-sgl';

export const consolidationTabs = {
  consolidationGroups: 'consolidation-groups',
  chartOfAccounts: 'chart-of-accounts',
  intercompanySets: 'intercompany-sets',
} as const;

export const sglSections = {
  mappedSgl: 'mapped-sgl',
  unmappedSgl: 'unmapped-sgl',
} as const;

export const consolidationURLs = {
  base: '/reporting/consolidation-mapping',
  _base_relative_path: 'consolidation-mapping',

  consolidationGroups: {
    base: '/reporting/consolidation-mapping/consolidation-groups',
  },

  chartOfAccounts: {
    base: '/reporting/consolidation-mapping/chart-of-accounts',
    mappedSgl:
      '/reporting/consolidation-mapping/chart-of-accounts?tab=mapped-sgl',
    unmappedSgl:
      '/reporting/consolidation-mapping/chart-of-accounts?tab=unmapped-sgl',
  },

  intercompanySets: {
    base: '/reporting/consolidation-mapping/intercompany-sets',
  },
} as const;
